// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2222 ? "d0dec1b0" : chunkId) + "." + {"996":"5d0e23cb1d1ba45f","2222":"5425050a60a01707","4291":"fb54107965c7167e","4799":"b8d8a86257b1b133"}[chunkId] + ".js";
};